module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_43.4c6eafc9.mp3";